// Added by Sejune Oh on 2020-03-02
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { FC } from 'react';
import {
    Paper as MaterialUIPaper,
    PaperProps as MaterialUIPaperProps
} from '@material-ui/core'

interface PaperBaseProps { }
export type PaperProps = Partial<MaterialUIPaperProps> & PaperBaseProps

export const Paper: FC<PaperProps> = ({ ...props }) => {
    return <MaterialUIPaper {...props}></MaterialUIPaper>
}
